<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/date.vue'

export default FormElement;
</script>